<script>
export default {
	name: 'IconSvgZip',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.3719 4.104C12.9072 4.10333 12.4616 3.92198 12.133 3.5997C11.8045 3.27743 11.6197 2.84055 11.6192 2.3849V0H3.78735C3.1807 0 2.59891 0.236249 2.16995 0.656782C1.74099 1.07731 1.5 1.64769 1.5 2.24241V15.7602C1.5009 16.3543 1.74229 16.9238 2.17115 17.3436C2.60001 17.7635 3.18129 17.9993 3.78735 17.9992H13.1892C13.7953 17.9993 14.3765 17.7635 14.8054 17.3436C15.2343 16.9238 15.4756 16.3543 15.4765 15.7602V4.104H13.3719Z"
				:fill="color" />
			<path
				d="M15.4766 4.104H13.372C12.9072 4.10333 12.4616 3.92198 12.1331 3.5997C11.8045 3.27743 11.6197 2.84055 11.6193 2.3849V0L15.4766 4.104Z"
				fill="#FFBC00" />
			<path
				d="M17.1349 14.2169H6.50646C5.75253 14.2169 5.14136 14.8161 5.14136 15.5552V18.6617C5.14136 19.4008 5.75253 20 6.50646 20H17.1349C17.8888 20 18.5 19.4008 18.5 18.6617V15.5552C18.5 14.8161 17.8888 14.2169 17.1349 14.2169Z"
				fill="#FFBC00" />
			<path d="M9.34964 17.7809V18.3867H8.70959V17.7809H9.34964Z" fill="#F3F3F6" />
			<path
				d="M10.3113 17.8977H11.4393V18.3868H9.62451V17.926L10.7346 16.3669H9.63896V15.8811H11.4325V16.3419L10.3113 17.8977Z"
				fill="#F3F3F6" />
			<path d="M12.4368 15.8811V18.3868H11.8214V15.8811H12.4368Z" fill="#F3F3F6" />
			<path
				d="M13.4816 17.5077V18.3868H12.8636V15.8811H13.8615C14.165 15.8811 14.397 15.9544 14.556 16.1028C14.6365 16.1801 14.6994 16.2732 14.7405 16.376C14.7817 16.4789 14.8002 16.5891 14.7948 16.6994C14.7975 16.8452 14.7605 16.989 14.6877 17.1161C14.6135 17.2403 14.5035 17.3403 14.3715 17.4035C14.2122 17.477 14.0375 17.5127 13.8615 17.5077H13.4816ZM14.1684 16.6994C14.1684 16.48 14.0443 16.3689 13.7961 16.3661H13.4816V17.0177H13.7961C14.0443 17.0205 14.1684 16.9144 14.1684 16.6994Z"
				fill="#F3F3F6" />
			<path
				d="M8.4871 12.7095C8.20124 12.7091 7.92723 12.5975 7.72518 12.3993C7.52312 12.201 7.40953 11.9323 7.4093 11.6521V10.5946H9.56575V11.6521C9.56553 11.9324 9.45181 12.2013 9.24957 12.3996C9.04733 12.5978 8.77311 12.7093 8.4871 12.7095ZM7.96095 11.1354V11.6521C7.96095 11.7889 8.01636 11.9202 8.115 12.0171C8.21365 12.114 8.34748 12.1685 8.4871 12.1687C8.6268 12.1685 8.76071 12.114 8.85949 12.0171C8.95828 11.9203 9.01387 11.789 9.0141 11.6521V11.1354H7.96095Z"
				fill="#FFBC00" />
			<path d="M7.40818 10.5955H8.48938V9.5355H7.40818V10.5955Z" fill="#FFBC00" />
			<path d="M8.48704 9.53625H9.56824V8.4763H8.48704V9.53625Z" fill="#FFBC00" />
			<path d="M7.40818 8.47717H8.48938V7.41722H7.40818V8.47717Z" fill="#FFBC00" />
			<path d="M8.48704 7.41797H9.56824V6.35802H8.48704V7.41797Z" fill="#FFBC00" />
		</svg>
	</div>

</template>

<style scoped>

</style>